import React, { useEffect, useState } from "react";
import { links } from "../../config/links";

interface NavProps {
  onOpenModal: () => void;
}

const sections = [
  { href: "#produtor", label: "Para o produtor" },
  { href: "#pagamento", label: "Pagamento" },
  { href: "#parceiro", label: "Para o parceiro" },
  { href: "#perguntas", label: "Perguntas" },
];

const Nav: React.FC<NavProps> = ({ onOpenModal }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 border-b transition-colors duration-200 ${
        scrolled
          ? "border-bone-300 bg-bone/95 backdrop-blur-sm"
          : "border-transparent bg-bone"
      }`}
    >
      <div className="mx-auto flex max-w-site items-center gap-4 px-5 py-3 lg:px-8">
        <a href="#top" className="flex shrink-0 items-center">
          <img
            src="/logo.png"
            alt="App Agro Negócios"
            className="h-12 w-auto lg:h-14"
          />
        </a>

        <nav className="ml-auto hidden items-center gap-7 lg:flex">
          {sections.map((s) => (
            <a
              key={s.href}
              href={s.href}
              className="inline-flex min-h-[2.75rem] items-center text-sm font-medium text-soil/70 transition-colors hover:text-agro-primary"
            >
              {s.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2 lg:ml-0">
          <a
            href={links.partnerSignup}
            className="hidden min-h-[2.75rem] items-center rounded-lg border border-soil/20 px-4 text-sm font-semibold text-soil transition-colors hover:border-soil/40 hover:bg-bone-200 sm:inline-flex"
          >
            Cadastrar empresa
          </a>
          <button
            onClick={onOpenModal}
            className="inline-flex min-h-[2.75rem] items-center rounded-lg bg-agro-primary px-4 text-sm font-semibold text-white transition-colors hover:bg-agro-secondary"
          >
            Quero o app
          </button>
          <button
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "Fechar menu" : "Abrir menu"}
            aria-expanded={open}
            className="flex h-11 w-11 items-center justify-center rounded-lg border border-soil/15 text-soil lg:hidden"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
            >
              {open ? (
                <>
                  <path d="M3.5 3.5l9 9" />
                  <path d="M12.5 3.5l-9 9" />
                </>
              ) : (
                <>
                  <path d="M2 4.5h12" />
                  <path d="M2 8h12" />
                  <path d="M2 11.5h12" />
                </>
              )}
            </svg>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-bone-300 bg-bone lg:hidden">
          <nav className="mx-auto flex max-w-site flex-col px-5 py-2">
            {sections.map((s) => (
              <a
                key={s.href}
                href={s.href}
                onClick={() => setOpen(false)}
                className="border-b border-bone-200 py-3 text-sm font-medium text-soil/80 last:border-0"
              >
                {s.label}
              </a>
            ))}
            <a
              href={links.partnerSignup}
              className="py-3 text-sm font-semibold text-agro-primary"
            >
              Cadastrar empresa
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Nav;
